export default "__VITE_ASSET__CdGgeq$O__"